var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "height": "auto",
      "width": _vm.isMobile ? '90vw' : '700px'
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "pop-title"
  }, [_vm._v(_vm._s(_vm.$lang("Task")))]), _c('div', {
    staticClass: "taskbox"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("用户编号")]), _c('div', {
    staticClass: "input"
  }, [_vm._v(" " + _vm._s(_vm.modifyData.user_id) + " ")])]), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("礼品编号")]), _c('div', {
    staticClass: "input"
  }, [_vm._v(" " + _vm._s(_vm.modifyData.gift_id) + " ")])]), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("图标")]), _c('div', {
    staticClass: "input"
  }, [_vm.modifyData.gift_thumb ? _c('img', {
    attrs: {
      "src": _vm.modifyData.gift_thumb,
      "height": "40px"
    }
  }) : _vm._e()])]), _vm.modifyData.gift_type == 1 ? _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("礼品原始ID")]), _c('div', {
    staticClass: "input"
  }, [_c('div', {
    staticClass: "custom-select"
  }, [_c('div', {
    staticClass: "selected-item",
    on: {
      "click": function ($event) {
        _vm.showOptions = !_vm.showOptions;
      }
    }
  }, [!_vm.gift_extra ? [_c('span', {
    staticClass: "option-text"
  }, [_vm._v("请选择一个NFT")])] : _vm.gift_extra ? [_c('img', {
    staticClass: "option-image",
    attrs: {
      "src": _vm.gift_extra.thumb,
      "alt": "Selected Image"
    }
  }), _c('span', {
    staticClass: "option-text"
  }, [_vm._v("名称：" + _vm._s(_vm.gift_extra.gift.name) + "，发送需星星：" + _vm._s(_vm.gift_extra.transfer_star_count))])] : _vm._e()], 2), _vm.showOptions ? _c('div', {
    staticClass: "options-container"
  }, _vm._l(_vm.gift_list, function (item, index) {
    return _c('div', {
      staticClass: "option"
    }, [_c('img', {
      staticClass: "option-image",
      attrs: {
        "src": item.thumb
      }
    }), _c('span', {
      staticClass: "option-text",
      on: {
        "click": function ($event) {
          _vm.modifyData.owner_gift_id = item.owned_gift_id, _vm.modifyData.gift_name = item.gift.name, _vm.modifyData.transfer_star_count = item.transfer_star_count, _vm.gift_extra = item;
          _vm.showOptions = false;
        }
      }
    }, [_vm._v("名称：" + _vm._s(item.gift.name) + "，发送需星星：" + _vm._s(item.transfer_star_count))])]);
  }), 0) : _vm._e()])])]) : _vm._e(), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("状态")]), _c('div', {
    staticClass: "input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modifyData.status,
      expression: "modifyData.status"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.modifyData, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("待处理")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("处理中")]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("已处理")]), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("处理失败")])])])])])]), _c('div', {
    staticClass: "btn",
    style: {
      background: _vm.themeMainColor(_vm.theme).main
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm.isSubmit ? [_vm._v(_vm._s(_vm.$lang("Submiting")))] : [_vm._v(_vm._s(_vm.$lang("Submit")))]], 2)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };